import { Tooltip } from 'components'
import { SizeDescription } from 'store/ProductContext/productContextTypes'

import * as S from './styles'

interface SizesTooltipProps {
  description: SizeDescription[]
}

const SizesTooltip = ({ description }: SizesTooltipProps) => {
  const renderContent = () => {
    return (
      <S.TableWrapper>
        <S.SizesTable cellSpacing={0}>
          <thead>
            <tr>
              <td>Tamanhos</td>
              {description.map((item) => (
                <td key={item.cd_tamh}>{item.cd_tamh}</td>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Pares [{description.reduce((acc, item) => acc + item.qt_matr, 0)}]</td>
              {description.map((item) => (
                <td key={item.cd_tamh}>{item.qt_matr}</td>
              ))}
            </tr>
          </tbody>
        </S.SizesTable>
      </S.TableWrapper>
    )
  }

  return (
    <Tooltip
      title={renderContent()}
      placement="top"
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            padding: 0,
            maxWidth: '100% !important'
          }
        }
      }}
    >
      <S.InfoIcon />
    </Tooltip>
  )
}

export default SizesTooltip
